import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const [posts, setPosts] = useState([]);
  const [editingPostId, setEditingPostId] = useState(null);
  const [editedData, setEditedData] = useState({ title: "", content: "" });
  const navigate = useNavigate();
  const role = localStorage.getItem("userRole");

  useEffect(() => {
    if (role !== "admin") {
      navigate("/");
    } else {
      fetchPosts();
    }
  }, []);

  const fetchPosts = async () => {
    try {
      const res = await axiosInstance.get("/posts");
      setPosts(res.data);
    } catch (err) {
      console.error("Error fetching posts:", err);
    }
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    try {
      await axiosInstance.delete(`/posts/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPosts((prev) => prev.filter((post) => post.id !== id));
    } catch (err) {
      alert("Failed to delete post");
    }
  };

  const handleEditClick = (post) => {
    setEditingPostId(post.id);
    setEditedData({ title: post.title, content: post.content });
  };

  const handleEditChange = (e) => {
    setEditedData({ ...editedData, [e.target.name]: e.target.value });
  };

  const handleCancelEdit = () => {
    setEditingPostId(null);
    setEditedData({ title: "", content: "" });
  };

  const handleSaveEdit = async (id) => {
    const token = localStorage.getItem("token");
    console.log("JWT token being sent:", token); 
    try {
      const res = await axiosInstance.put(
        `/posts/${id}`,
        { title: editedData.title, content: editedData.content },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Update post in state
      setPosts((prev) =>
        prev.map((post) => (post.id === id ? res.data : post))
      );

      setEditingPostId(null);
    } catch (err) {
      alert("Failed to update post");
    }
  };

  return (
    <div className="adminContainer">
      <h2 className="adminTitle">Admin Post Management</h2>
      {posts.map((post) => (
        <div key={post.id} className="postCard">
          {editingPostId === post.id ? (
            <>
              <input
                type="text"
                name="title"
                value={editedData.title}
                onChange={handleEditChange}
                placeholder="Edit title"
              />
              <textarea
                name="content"
                value={editedData.content}
                onChange={handleEditChange}
                placeholder="Edit content"
              />
              <div style={{ marginTop: "0.5rem" }}>
                <button onClick={() => handleSaveEdit(post.id)} className="saveBtn">
                  Save
                </button>
                <button onClick={handleCancelEdit} className="cancelBtn">
                  Cancel
                </button>
              </div>
            </>
          ) : (
            <>
              <h3>{post.title}</h3>
              <p>{post.content}</p>
              {post.media_url && (
                post.media_url.endsWith(".mp4") ? (
                  <video src={`http://localhost:5000${post.media_url}`} controls className="postMedia" />
                ) : (
                  <img src={`http://localhost:5000${post.media_url}`} alt="Post media" className="postMedia" />
                )
              )}
              <div style={{ marginTop: "0.5rem" }}>
                <button onClick={() => handleEditClick(post)} className="editBtn">
                  Edit
                </button>
                <button onClick={() => handleDelete(post.id)} className="deleteBtn">
                  Delete
                </button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AdminDashboard;
